import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ctfo-info-dialog',
    templateUrl: './info-dialog.component.html',
    styleUrls: ['./info-dialog.component.scss'],
    standalone: false
})
export class InfoDialogComponent {
  @Input() title: string;
  @Input() message: string;

  @Output() afterClose = new EventEmitter<void>();
}
